import { render, staticRenderFns } from "./DragHelper.vue?vue&type=template&id=fae8e7d4&"
import script from "./DragHelper.vue?vue&type=script&lang=js&"
export * from "./DragHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports